import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService, CommonPortalUrlService } from 'gast-portal-ng';
import { TranslationService, Product } from 'gast-common-ng';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private commonPortalUrlService: CommonPortalUrlService,
        private translationService: TranslationService
    ) { }

    canActivate(): Observable<boolean> {
        return this.http.get(this.commonPortalUrlService.getUserInfo(), { withCredentials: true }).pipe(
            map((response: any) => {
                if (response && response.name) {
                    this.authService.saveUserObjectInStorage(response.name, response.principal.longusername);
                    return true;
                } else {
                    return this.handleNotLoggedIn();
                }
            }),
            catchError((err) => {
                console.log('failed to retrieve user-info', err);
                return of(false);
            })
        );
    }

    private handleNotLoggedIn() {
        this.authService.saveUserObjectInStorage(null, null);
        window.location.href = this.commonPortalUrlService.
            getPortalAccountLoginUrl(Product.ONSET, this.translationService);
        return false;
    }
}
